<template>
<div>
        <span
            v-for="doctor in doctors" :key="doctor.id"
        >
            <span class="colorbox" :style="{background: doctor.color}"></span>
            <span class="doctorname">{{doctor_name(doctor.doctor)}}</span>
        </span>
</div>
</template>

<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import axios from 'axios';
import {mapGetters} from 'vuex';
/* eslint-disable */

export default {
  name: 'FooterColor',
  components: {
  },
    computed: {
        ...mapGetters(['user', 'user_name', 'is_admin']),
    },

  data() {  // datas
    return {
        doctors: [],
    };
  },
  created() {
    console.log('%ccreated: FooterColor.vue', mycolor.purple);
    this.getDoctors();
  },
  methods: {
    getDoctors() {
            axios.get('/get_doctors')
              .then((res) => {
                console.group();
                console.log('%c /get_doctors', mycolor.api);
                console.log('担当医のリスト取得');
                console.log('res: ', res.data);
                console.groupEnd();

                for(let i=0; i<res.data.length; i++){
                    if(res.data[i].doctor==='担当医不明・特に希望しない'){
                        res.data[i].doctor = '未選択'
                    }
                }
                this.doctors = res.data;
              })
              .catch((error) => {
                // eslint-disable-next-line
                console.error(error);
              });
    },
    doctor_name(v){
        console.log('doctor_name: ', v);
        return v;
    },
  },
  mounted() {
  }
}
</script>
